import { getEventEmitter } from "@process-advisor/process-miner/processMiner/processMiner";
import { Event } from "@process-advisor/process-miner/api/events";

export type Props = {
  status?: string;
  ai?: boolean;
};

export function openProgressModal({ status, ai }: Props = {}) {
  getEventEmitter().emit(Event.openProgressModal, { status, ai });
}